import { HeroImage } from "../../components/static-page-components/hero-image";
import heroImageMobile from "../../assets/join-as-designer-page/hero-mobile.jpg";
import heroImage from "../../assets/join-as-designer-page/hero-desktop.jpg";
import { LandingPageSection } from "../../components/static-page-components/landing-page-section";
import { Button, Grid2, Stack, Typography } from "@mui/material";
import { Link } from "react-router";
import "./styles.scss";
import { Accordion } from "../../components/accordion";
import { Pages, sectionPadding } from "../../utils";
import { StickyContentSection } from "./sticky-content-section";
import { TheVettingProcess } from "../../components/the-vetting-process";

export const JoinAsADesignerPage = () => {
  return (
    <div className="join-as-a-designer-page static-page">
      <HeroImage
        className="join-as-a-designer-page-hero"
        image={heroImage}
        mobileImage={heroImageMobile}
        imageBreakPoint={1200}
        sx={{
          backgroundPosition: "center 50%",
          minHeight: {
            xs: "850px",    // <600px
            sm: "850px",    // ≥600px
            md: "650px",    // ≥900px
            lg: "764px",    // ≥1200px
            xl: "764px",    // ≥1536px
          },
        }}
      >
        <Stack
          alignContent={"center"}
          justifyContent="center"
          alignItems="center"
          height="100%"
        >
          <Grid2 container columns={12} className="hero-grid">
            <Grid2 size={{ xs: 12, md: 6 }} style={{ minHeight: "50%" }} />
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Stack
                spacing={2}
                className="hero-content"
                sx={{ ...sectionPadding, maxWidth: 510, mx: "auto" }}
              >
                <Typography
                  variant="h3"
                  className="title font-body font-size-6"
                >
                  Why Partner With Home Design Guild?
                </Typography>
                <Typography variant="body1" className="description font-size-3">
                  We are a designer-first, designer only platform with a mission
                  to empower the relationship between Interior Designers and
                  Homeowners. We help you build a sustainable client pipeline
                  through regional marketing & smart matchmaking.
                </Typography>
                <div>
                  <Button
                    variant="contained"
                    component={Link}
                    to={Pages.SIGNUP}
                    size="large"
                    className="thin"
                  >
                    Get Started Today!
                  </Button>
                </div>
              </Stack>
            </Grid2>
          </Grid2>
        </Stack>
      </HeroImage>

      <LandingPageSection className="text-center">
        <Typography
          variant={"display2" as any}
          component="h2"
          sx={{ mb: "24px !important" }}
          className="text-pink"
        >
          GROW YOUR BUSINESS ON YOUR TERMS
        </Typography>
        <Typography
          variant="h5"
          component="p"
          className="font-size-3 contain-title"
          sx={{ mx: "auto", fontWeight: 400 }}
        >
          An introductory price for first 20 members per territory. We will
          request your feedback as our early adopters. It is good for the first
          year of service only and will renew at the non-Beta Rate.
        </Typography>
      </LandingPageSection>

      <LandingPageSection>
        <StickyContentSection />
      </LandingPageSection>

      {/* <SplitScreenBlock
        image={idealClientImage}
        title="Every Client, Exceptional"
        titleClassName="font-body"
        description="Home Design Guild eliminates the guesswork of fielding prospective projects to ensure you’re building on a foundation of chemistry and compatibility. Launch every project with the comfort of knowing your client has the knowledge, empathy, and understanding to let you do your best work."
        linkText="Our Homeowners"
        to={Pages.COMING_SOON}
        reverse
        backgroundImage
      />
      <SplitScreenBlock
        image={leadGenerationImage}
        title="Centralized Success"
        titleClassName="font-body"
        description="Our Designer Hub lets you experience simple, streamlined functionality — all in one place, right at your fingertips. Manage your matches, earn passive income, hire a third party service and collaborate with other designers."
        linkText="Learn More"
        to={Pages.ABOUT_DESIGN_HUB}
        backgroundImage
      />
      <SplitScreenBlock
        title="Own Your Space"
        titleClassName="font-body"
        description="Wherever you are, Home Design Guild helps you stand out as a premier expert in your region. We limit the number of designers per territory to maximize the potential of your return on investment. With our Home Design Guild Seal of Approval, you’re in a new class of professionals."
        linkText="Regional Advertising"
        image={territoryImage}
        to={Pages.COMING_SOON}
        reverse
        backgroundImage
      />

      <LandingPageSection className="take-charge-section text-center">
        <h3 className="font-body title margin-0 font-size-6">
          Connect with your peers, build your network.
        </h3>
        <Button
          component={Link}
          to={Pages.SIGNUP}
          variant="contained"
          color={"white" as any}
          size="large"
          className="font-size-4"
        >
          Join the Guild Now
        </Button>
      </LandingPageSection>

      <LandingPageSection className="process-section">
        <p className="margin-0 section-sub-heading text-center font-size-4">
          UNTANGLE THE PROCESS
        </p>
        <h3 className="section-title text-center font-body font-size-6">
          Get The Most Out of Your Membership
        </h3>
        <p className="section-description text-center font-size-4">
          Designers and their prospective clients are searching for the same
          things: fulfilling projects, beautiful spaces, and collaborative
          relationships that elevate the experience of working together. We
          ensure you’re on the same page from the very start.
        </p>
        <Grid2 container columns={12} spacing={4}>
          <Grid2
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <ImageTitleTextBlock
              image={growImage}
              title="Grow Your Business on Your Terms"
              text="Expand your business pipeline and build a portfolio of perfect matches. We focus on helping you build a better business so you can focus on doing what you were hired to do, creating beautiful spaces."
            />
          </Grid2>
          <Grid2
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <ImageTitleTextBlock
              image={campaignImage}
              title="Amplify Your Signal"
              text="A portion of every designer’s membership fees are allocated directly to their specific territory’s marketing budget. Allowing for marketing campaigns that fully maximize the marketing funnel, creating more demand for a fraction of what it would cost you to go it alone."
            />
          </Grid2>
        </Grid2>
      </LandingPageSection> */}

      <TheVettingProcess sx={{ position: "relative" }} />

      <LandingPageSection
        className="faq-section"
        id="faq"
        sx={{ position: "relative", background: "#fff" }}
      >
        <Accordion
          items={[
            {
              title: "How is Home Design Guild different from Houzz?",
              description:
                "We are so different. Home Design Guild will never tell you that we own your content  once you load it and certainly will never tag the products in your images to sell direct. We vet and limit the number of designers in our community. We focus exclusively on interior designers and decorators and connect you with educated, real client leads.",
            },
            {
              title: "Is my territory capped?",
              description:
                "Yes! We limit the number of designers in each region. This ensures fair competition and gives you maximum visibility in your local market.",
            },
            {
              title: "Can I monetize my designs and idea books?",
              description:
                "When you sign up for our DESIGN MEMBERSHIP you have access to our Designer Files Revenue Share model. Get paid to showcase your work!",
            },
            {
              title: "How does Smart-Guild Technology work?",
              description:
                "We start with the relationship first, because let’s face it - if the relationship isn’t great, the project is not going to be either. Using advanced algorithms, we match you with homeowners based first on personal compatibility, then on preferences and lastly based on the project needs. ",
            },
            {
              title: "Are clients educated about the design process?",
              description:
                "Yes! Our Guild Guides are a resource for homeowners to educate themselves on how designers work and set realistic expectations for the process. We want to give them the confidence to embark on their project, the know-how to work well with you and ultimately create a smoother onboarding process for you!",
            },
          ]}
        />
      </LandingPageSection>

      <LandingPageSection
        className="start-fueling-your-future-section text-center"
        sx={{ position: "relative" }}
      >
        <Typography
          variant="h4"
          mb="20px !important"
          className="section-title title font-body font-size-6"
        >
          Ready to Fuel Your Business Growth?
        </Typography>
        <Typography
          variant="h6"
          mb="28px !important"
          component="p"
          fontWeight={400}
          className="section-subtitle font-size-4"
        >
          Expand your business pipeline and build a portfolio of perfect
          matches.
        </Typography>
        <Button
          variant="contained"
          component={Link}
          to={Pages.DESIGN_COMMUNITY}
          color={"white" as any}
          size="large"
          className="font-size-4"
        >
          The Process
        </Button>
      </LandingPageSection>
    </div>
  );
};
